import React from 'react';
import PricingPolicyForm from './PricingPolicyForm';

const EditPricingPolicy = () => {
  return <PricingPolicyForm mode="edit" />;
};

export default EditPricingPolicy;
